// Configuración de imágenes
const carouselImages = [
  'https://cdn.shopify.com/s/files/1/0851/5826/5179/files/skull-hearts-drop-02-hoodie-jesus-died-contrapicado.webp?v=1751287785&width=320&format=webp&quality=70',
  'https://cdn.shopify.com/s/files/1/0851/5826/5179/files/hoodie_skullhearts_jesus_died_back_lifestyle_night_shoot.webp?v=1751288670&width=320&format=webp&quality=70',
  'https://cdn.shopify.com/s/files/1/0851/5826/5179/files/Foto_Camiseta_roja_Alternativa_Drop_01.webp?v=1751290511&width=320&format=webp&quality=70',
  'https://cdn.shopify.com/s/files/1/0851/5826/5179/files/skull-hearts-drop-02-accesorios-cruz-anillos-detalle.webp?v=1751289918&width=320&format=webp&quality=70',
  'https://cdn.shopify.com/s/files/1/0851/5826/5179/files/Foto_Camiseta_Roja_Por_Detras_Drop_01.webp?v=1751290511&width=320&format=webp&quality=70',
  'https://cdn.shopify.com/s/files/1/0851/5826/5179/files/skull-hearts-drop-02-hoodie-jesus-died-espalda.webp?v=1751288618&width=320&format=webp&quality=70'
];

const lightboxImages = [
  'https://cdn.shopify.com/s/files/1/0851/5826/5179/files/skull-hearts-drop-02-hoodie-jesus-died-contrapicado.webp?v=1751287785',
  'https://cdn.shopify.com/s/files/1/0851/5826/5179/files/hoodie_skullhearts_jesus_died_back_lifestyle_night_shoot.webp?v=1751288670',
  'https://cdn.shopify.com/s/files/1/0851/5826/5179/files/Foto_Camiseta_roja_Alternativa_Drop_01.webp?v=1751290511',
  'https://cdn.shopify.com/s/files/1/0851/5826/5179/files/skull-hearts-drop-02-accesorios-cruz-anillos-detalle.webp?v=1751289918',
  'https://cdn.shopify.com/s/files/1/0851/5826/5179/files/Foto_Camiseta_Roja_Por_Detras_Drop_01.webp?v=1751290511',
  'https://cdn.shopify.com/s/files/1/0851/5826/5179/files/skull-hearts-drop-02-hoodie-jesus-died-espalda.webp?v=1751288618'
];

let currentImageIndex = 0;
let isDragging = false;
let suppressClickUntil = 0;
let startX = 0;
let initialTransform = 0; // POSICIÓN INICIAL AL EMPEZAR EL DRAG
let velocity = 0;
let animationId = null;
let lastTime = Date.now();
let lastX = 0;

// Señal para desactivar scripts legacy que puedan pisar el drag
/** @type {any} */ (window).__skullInfiniteCarouselEnhanced = true;

// Crear carrusel infinito
function createInfiniteCarousel() {
  const track = document.getElementById('carouselTrack');
  if (!track) return;
  
  for (let set = 0; set < 2; set++) {
    const content = document.createElement('div');
    content.className = 'carousel-content';
    content.id = `carousel-set-${set}`;
    
    // Orden optimizado para evitar repeticiones consecutivas: [1,2,3,4,5,6,4,5,6,1,2,3]
    const optimizedOrder = [0, 1, 2, 3, 4, 5, 3, 4, 5, 0, 1, 2];
    
    optimizedOrder.forEach((imageIndex) => {
      const img = carouselImages[imageIndex];
      if (!img) return;
      const item = document.createElement('div');
      item.className = 'carousel-item';
      item.onclick = (e) => {
        if (isDragging || Date.now() < suppressClickUntil) return;
        openLightbox(imageIndex);
      };
      item.tabIndex = 0;
      item.setAttribute('role', 'button');
      item.setAttribute('aria-label', 'Ver imagen en pantalla completa');
      
      const image = document.createElement('img');
      image.src = img;
      image.alt = `Lifestyle streetwear ${imageIndex + 1}`;
      image.loading = 'lazy';
      image.width = 320;
      image.height = 420;
      image.draggable = false;
      
      item.appendChild(image);
      content.appendChild(item);
    });
    
    track.appendChild(content);
  }
  
  // Inicializar drag & swipe
  initDragAndSwipe();
}

// Sistema simple: automático + pausa total al interactuar
function initDragAndSwipe() {
  /** @type {HTMLElement | null} */
  const wrapper = document.querySelector('.carousel-wrapper');
  const track = document.getElementById('carouselTrack');
  if (!wrapper || !track) return;

  /** @type {NodeListOf<HTMLElement>} */
  const contents = track.querySelectorAll('.carousel-content');
  const controlTrack = document.getElementById('controlTrack');
  const controlProgress = document.getElementById('controlProgress');
  const playBtn = document.getElementById('playBtn');
  const pauseBtn = document.getElementById('pauseBtn');

  if (!contents.length || !controlTrack || !controlProgress || !playBtn || !pauseBtn) return;

  const wrapperEl = /** @type {HTMLElement} */ (wrapper);
  const controlTrackEl = /** @type {HTMLElement} */ (controlTrack);
  const controlProgressEl = /** @type {HTMLElement} */ (controlProgress);
  const playBtnEl = /** @type {HTMLElement} */ (playBtn);
  const pauseBtnEl = /** @type {HTMLElement} */ (pauseBtn);
  
  let isUserControlling = false;
  let isManuallyPaused = false; // Nueva variable para controlar pausa manual
  let animationStartTime = Date.now();
  let pausedTime = 0; // Tiempo acumulado mientras estaba pausado
  let pauseStartTime = 0; // Momento cuando se pausó

  // Duración real de la animación CSS (por defecto 50s)
  const ANIMATION_DURATION = (() => {
    const first = contents && contents[0];
    if (!first) return 50000;
    const duration = window.getComputedStyle(first).animationDuration;
    if (!duration) return 50000;
    // Puede venir como "50s" o "50000ms" o lista separada por comas
    const token = (duration.split(',')[0] || '').trim();
    if (token.endsWith('ms')) return parseFloat(token) || 50000;
    if (token.endsWith('s')) return (parseFloat(token) || 50) * 1000;
    return 50000;
  })();
  /** @type {number | undefined} */
  let controlTimeout;
  
  // Configurar estado inicial de los botones
  function updatePlaybackButtons() {
    if (isManuallyPaused) {
      playBtnEl.classList.add('active');
      pauseBtnEl.classList.remove('active');
      playBtnEl.style.display = 'flex';
      pauseBtnEl.style.display = 'none';
    } else {
      playBtnEl.classList.remove('active');
      pauseBtnEl.classList.add('active');
      playBtnEl.style.display = 'none';
      pauseBtnEl.style.display = 'flex';
    }
  }
  
  // Función para pausar manualmente
  function pauseCarousel() {
    isManuallyPaused = true;
    isUserControlling = true;
    pauseStartTime = Date.now(); // Registrar cuándo se pausó
    contents.forEach(content => content.classList.add('paused'));
    clearTimeout(controlTimeout);
    updatePlaybackButtons();
  }
  
  // Función para reanudar manualmente
  function playCarousel() {
    if (isManuallyPaused && pauseStartTime > 0) {
      // Acumular el tiempo que estuvo pausado
      pausedTime += Date.now() - pauseStartTime;
      pauseStartTime = 0;
    }
    isManuallyPaused = false;
    isUserControlling = false;
    contents.forEach(content => {
      content.style.animation = '';
      content.style.transform = '';
      content.classList.remove('paused');
    });
    updatePlaybackButtons();
  }
  
  // Event listeners para los botones
  playBtn.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    playCarousel();
  });
  
  pauseBtn.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    pauseCarousel();
  });
  
  // Inicializar estado de botones
  updatePlaybackButtons();
  
  // Actualizar progreso visual - PAUSAR línea cuando está pausado
  function updateProgress() {
    if (!isUserControlling && !isManuallyPaused) {
      // Calcular tiempo efectivo descontando el tiempo pausado
      const currentPausedTime = isManuallyPaused && pauseStartTime > 0 
        ? pausedTime + (Date.now() - pauseStartTime)
        : pausedTime;
      
      const effectiveTime = Date.now() - animationStartTime - currentPausedTime;
      const elapsed = effectiveTime % ANIMATION_DURATION;
      const progress = (elapsed / ANIMATION_DURATION) * 100;
      
      controlProgressEl.style.width = Math.max(0, Math.min(100, progress)) + '%';
    }
    requestAnimationFrame(updateProgress);
  }
  updateProgress();
  
  // Control de barra simplificado: pausa total + reanudación
  let isDraggingControl = false;
  
  function startUserControl() {
    if (!isManuallyPaused) { // Solo pausar si no está pausado manualmente
      isUserControlling = true;
      pauseStartTime = Date.now(); // Iniciar conteo de pausa temporal
      contents.forEach(content => content.classList.add('paused'));
      clearTimeout(controlTimeout);
    }
  }
  
  function endUserControl() {
    if (!isManuallyPaused) { // Solo reanudar si no está pausado manualmente
      controlTimeout = setTimeout(() => {
        // Acumular tiempo de pausa temporal
        if (pauseStartTime > 0) {
          pausedTime += Date.now() - pauseStartTime;
          pauseStartTime = 0;
        }
        isUserControlling = false;
        contents.forEach(content => {
          content.style.animation = '';
          content.style.transform = '';
          content.classList.remove('paused');
        });
      }, 1500);
    }
  }
  
  /** @param {MouseEvent | TouchEvent} e */
  function handleControlInteraction(e) {
    const rect = controlTrackEl.getBoundingClientRect();
    let x = 0;
    if (typeof TouchEvent !== 'undefined' && e instanceof TouchEvent) {
      x = e.touches && e.touches[0] ? e.touches[0].clientX : 0;
    } else {
      x = /** @type {MouseEvent} */ (e).clientX;
    }
    const percentage = Math.max(0, Math.min(100, ((x - rect.left) / rect.width) * 100));
    
    // Actualizar visualmente la barra de progreso
    controlProgressEl.style.width = percentage + '%';
    
    // Ajustar el tiempo de animación para sincronizar con la posición
    // Resetear el tiempo pausado ya que estamos estableciendo una nueva posición
    pausedTime = 0;
    pauseStartTime = 0;
    animationStartTime = Date.now() - (percentage / 100) * ANIMATION_DURATION;
    
    // Si no está pausado manualmente, mover el carrusel proporcionalmente
    if (!isManuallyPaused) {
      // Reposicionar la animación (la animación CSS manda sobre transform)
      const delaySeconds = -((percentage / 100) * ANIMATION_DURATION) / 1000;
      contents.forEach(content => {
        content.style.animation = '';
        content.style.animationDelay = `${delaySeconds}s`;
      });
    }
  }
  
  // Event listeners para la barra de control
  controlTrack.addEventListener('mousedown', (e) => {
    startUserControl();
    isDraggingControl = true;
    handleControlInteraction(e);
    
    /** @param {MouseEvent} e */
    const mouseMoveHandler = (e) => {
      if (isDraggingControl) handleControlInteraction(e);
    };
    
    const mouseUpHandler = () => {
      isDraggingControl = false;
      document.removeEventListener('mousemove', mouseMoveHandler);
      document.removeEventListener('mouseup', mouseUpHandler);
      endUserControl();
    };
    
    document.addEventListener('mousemove', mouseMoveHandler);
    document.addEventListener('mouseup', mouseUpHandler);
  });
  
  controlTrack.addEventListener('touchstart', (e) => {
    startUserControl();
    isDraggingControl = true;
    handleControlInteraction(e);
    
    /** @param {TouchEvent} e */
    const touchMoveHandler = (e) => {
      if (isDraggingControl) {
        e.preventDefault();
        handleControlInteraction(e);
      }
    };
    
    const touchEndHandler = () => {
      isDraggingControl = false;
      document.removeEventListener('touchmove', touchMoveHandler);
      document.removeEventListener('touchend', touchEndHandler);
      endUserControl();
    };
    
    document.addEventListener('touchmove', touchMoveHandler, { passive: false });
    document.addEventListener('touchend', touchEndHandler);
  });
  
  // Click simple en la barra
  controlTrack.addEventListener('click', (e) => {
    if (!isDraggingControl) {
      startUserControl();
      handleControlInteraction(e);
      endUserControl();
    }
  });
  
  // DRAG INTELIGENTE CON SINCRONIZACIÓN COMPLETA
  let isDraggingImages = false;
  let hasMoved = false;
  let dragStartX = 0;
  let lastDragX = 0;
  /** @type {number[]} */
  let initialTransforms = [];
  let initialProgress = 0;
  let moveDistancePx = 0;
  /** @type {number | null} */
  let activePointerId = null;

  /** @returns {number} */
  function getMoveDistancePx() {
    const first = contents && contents[0];
    const width = first ? first.scrollWidth : 0;
    return width > 0 ? width / 2 : Math.max(1, wrapperEl.offsetWidth * 2);
  }

  /** @param {number} x */
  function normalizeTransformX(x) {
    if (!moveDistancePx) return x;
    let normalized = x % moveDistancePx;
    if (normalized > 0) normalized -= moveDistancePx;
    return normalized;
  }

  function computeCurrentProgress() {
    const currentPausedTime = isManuallyPaused && pauseStartTime > 0
      ? pausedTime + (Date.now() - pauseStartTime)
      : pausedTime;
    const effectiveTime = Date.now() - animationStartTime - currentPausedTime;
    const elapsed = ((effectiveTime % ANIMATION_DURATION) + ANIMATION_DURATION) % ANIMATION_DURATION;
    return (elapsed / ANIMATION_DURATION) * 100;
  }

  /** @param {number} transformPx */
  function progressFromTransformPx(transformPx) {
    if (!moveDistancePx) return 0;
    // transform es negativo cuando avanza hacia la izquierda
    const raw = ((-transformPx) / moveDistancePx) * 100;
    let progress = raw % 100;
    if (progress < 0) progress += 100;
    return progress;
  }

  /** @param {number} deltaPx */
  function progressFromDelta(deltaPx) {
    const deltaPercent = (deltaPx / moveDistancePx) * 100;
    let progress = (initialProgress - deltaPercent) % 100;
    if (progress < 0) progress += 100;
    return progress;
  }

  /** @param {number} clientX */
  function beginDrag(clientX) {
    isDraggingImages = true;
    hasMoved = false;
    isDragging = false;
    suppressClickUntil = 0;

    dragStartX = clientX;
    lastDragX = clientX;
    moveDistancePx = getMoveDistancePx();

    // Importante: NO tocamos la animación aquí.
    // Así un simple click sigue abriendo el lightbox sin "micro-freeze".
  }

  /** @param {number} clientX */
  function updateDrag(clientX) {
    if (!isDraggingImages) return;

    const deltaX = (clientX - dragStartX) * 1.2;
    lastDragX = clientX;

    if (!hasMoved && Math.abs(deltaX) > 6) {
      hasMoved = true;
      isDragging = true;
      suppressClickUntil = Date.now() + 250;
      wrapperEl.classList.add('dragging');

      if (activePointerId != null) {
        wrapperEl.setPointerCapture?.(activePointerId);
      }

      // Entramos en modo drag real: congelar el frame actual y pasar a transform inline.
      isUserControlling = true;
      pauseStartTime = Date.now();

      initialTransforms = [];
      contents.forEach(content => {
        initialTransforms.push(getTransformX(content));
      });

      initialProgress = progressFromTransformPx(initialTransforms[0] || 0);
      controlProgressEl.style.width = initialProgress + '%';

      contents.forEach((content, idx) => {
        content.classList.add('paused');
        content.style.animation = 'none';
        const frozen = normalizeTransformX(initialTransforms[idx] || 0);
        content.style.transform = `translateX(${frozen}px)`;
      });
    }

    if (!hasMoved) return;

    contents.forEach((content, index) => {
      const newTransform = normalizeTransformX((initialTransforms[index] || 0) + deltaX);
      content.style.transform = `translateX(${newTransform}px)`;
    });

    const newProgress = progressFromDelta(deltaX);
    controlProgressEl.style.width = newProgress + '%';
  }

  function endDrag() {
    if (!isDraggingImages) return;
    isDraggingImages = false;

    // Si fue click (sin arrastre real), no tocar animación ni tiempos.
    if (!hasMoved) {
      wrapperEl.classList.remove('dragging');
      setTimeout(() => {
        isDragging = false;
      }, 0);
      return;
    }

    wrapperEl.classList.remove('dragging');

    if (pauseStartTime > 0) {
      pausedTime += Date.now() - pauseStartTime;
      pauseStartTime = 0;
    }

    const finalDelta = (lastDragX - dragStartX) * 1.2;
    const finalProgress = progressFromDelta(finalDelta);
    animationStartTime = Date.now() - (finalProgress / 100) * ANIMATION_DURATION - pausedTime;

    const delaySeconds = -((finalProgress / 100) * ANIMATION_DURATION) / 1000;

    if (!isManuallyPaused) {
      isUserControlling = false;
      // Reanudar inmediatamente en el punto exacto, sin saltos
      requestAnimationFrame(() => {
        contents.forEach(content => {
          content.style.animation = '';
          content.style.animationDelay = `${delaySeconds}s`;
          content.style.transform = '';
          content.classList.remove('paused');
        });
      });
    } else {
      isUserControlling = false;
    }

    // Reset de guardias de click (el click se dispara después del pointerup)
    setTimeout(() => {
      isDragging = false;
    }, 0);
  }

  wrapper.addEventListener('pointerdown', (e) => {
    const pe = /** @type {PointerEvent} */ (e);
    if (pe.button != null && pe.button !== 0) return;

    const target = pe.target instanceof HTMLElement ? pe.target : null;
    if (target && (target.closest('.simple-control') || target.closest('.playback-controls'))) return;

    beginDrag(pe.clientX);
    activePointerId = pe.pointerId;
  });

  wrapper.addEventListener('pointermove', (e) => {
    if (!isDraggingImages) return;
    const pe = /** @type {PointerEvent} */ (e);
    updateDrag(pe.clientX);
    if (hasMoved) pe.preventDefault();
  });

  wrapper.addEventListener('pointerup', (e) => {
    endDrag();
    activePointerId = null;
  });

  wrapper.addEventListener('pointercancel', () => {
    endDrag();
    activePointerId = null;
  });
  
  /** @param {HTMLElement} element */
  function getTransformX(element) {
    const style = window.getComputedStyle(element);
    const matrix = style.transform;
    if (matrix === 'none') return 0;
    const match = matrix.match(/matrix.*\((.+)\)/);
    if (!match || !match[1]) return 0;
    const values = match[1].split(',');
    return parseFloat((values[4] || '0').trim()) || 0;
  }
}

// Lightbox mejorado
/** @param {number} index */
function openLightbox(index) {
  currentImageIndex = index;
  const lightbox = document.getElementById('carousel-lightbox');
  const lightboxImg = /** @type {HTMLImageElement | null} */ (document.getElementById('lightbox-image'));
  const loading = document.getElementById('lightboxLoading');
  const currentIndexEl = document.getElementById('currentIndex');
  const totalImagesEl = document.getElementById('totalImages');

  if (!lightbox || !lightboxImg || !loading || !currentIndexEl || !totalImagesEl) return;
  
  // Actualizar contador
  currentIndexEl.textContent = String(index + 1);
  totalImagesEl.textContent = String(lightboxImages.length);
  
  // Mostrar loading
  loading.classList.add('show');
  lightboxImg.classList.remove('loaded');
  
  // Cargar imagen HD
  const img = new Image();
  img.onload = () => {
    lightboxImg.src = lightboxImages[index] || '';
    lightboxImg.classList.add('loaded');
    loading.classList.remove('show');
    
    // Precargar imágenes adyacentes
    preloadAdjacentImages(index);
  };
  img.src = lightboxImages[index] || '';
  
  lightbox.classList.add('active');
  lightbox.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
}

/** @param {number} index */
function preloadAdjacentImages(index) {
  const indices = [
    (index - 1 + lightboxImages.length) % lightboxImages.length,
    (index + 1) % lightboxImages.length
  ];
  
  indices.forEach(i => {
    const img = new Image();
    img.src = lightboxImages[i] || '';
  });
}

function closeLightbox() {
  const lightbox = document.getElementById('carousel-lightbox');
  if (!lightbox) return;
  lightbox.classList.remove('active');
  lightbox.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
}

function nextImage() {
  currentImageIndex = (currentImageIndex + 1) % lightboxImages.length;
  updateLightboxImage();
}

function prevImage() {
  currentImageIndex = (currentImageIndex - 1 + lightboxImages.length) % lightboxImages.length;
  updateLightboxImage();
}

function updateLightboxImage() {
  const lightboxImg = /** @type {HTMLImageElement | null} */ (document.getElementById('lightbox-image'));
  const loading = document.getElementById('lightboxLoading');
  const currentIndexEl = document.getElementById('currentIndex');

  if (!lightboxImg || !loading || !currentIndexEl) return;
  
  currentIndexEl.textContent = String(currentImageIndex + 1);
  
  loading.classList.add('show');
  lightboxImg.classList.remove('loaded');
  
  const img = new Image();
  img.onload = () => {
    lightboxImg.src = lightboxImages[currentImageIndex] || '';
    lightboxImg.classList.add('loaded');
    loading.classList.remove('show');
    preloadAdjacentImages(currentImageIndex);
  };
  img.src = lightboxImages[currentImageIndex] || '';
}

// Keyboard navigation
document.addEventListener('keydown', function(e) {
  const lightbox = document.getElementById('carousel-lightbox');
  if (lightbox && lightbox.classList.contains('active')) {
    switch(e.key) {
      case 'Escape':
        closeLightbox();
        break;
      case 'ArrowLeft':
        prevImage();
        break;
      case 'ArrowRight':
        nextImage();
        break;
    }
  }
});

// Touch swipe en lightbox
let lightboxTouchStartX = 0;
let lightboxTouchEndX = 0;

document.addEventListener('DOMContentLoaded', function() {
  /** @type {any} */ (window).__skullInfiniteCarouselEnhanced = true;
  const lightbox = document.getElementById('carousel-lightbox');
  if (lightbox) {
    const imgWrapper = lightbox.querySelector('.lightbox-img-wrapper');

    if (imgWrapper) {
      imgWrapper.addEventListener('touchstart', e => {
        const te = /** @type {TouchEvent} */ (e);
        if (te.changedTouches && te.changedTouches[0]) {
          lightboxTouchStartX = te.changedTouches[0].screenX;
        }
      }, { passive: true });
      
      imgWrapper.addEventListener('touchend', e => {
        const te = /** @type {TouchEvent} */ (e);
        if (te.changedTouches && te.changedTouches[0]) {
          lightboxTouchEndX = te.changedTouches[0].screenX;
        }
        handleLightboxSwipe();
      }, { passive: true });
    }
  }
  
  // Inicializar carrusel
  createInfiniteCarousel();
});

function handleLightboxSwipe() {
  const swipeThreshold = 50;
  const diff = lightboxTouchStartX - lightboxTouchEndX;
  
  if (Math.abs(diff) > swipeThreshold) {
    if (diff > 0) {
      nextImage();
    } else {
      prevImage();
    }
  }
}
